import { useState } from 'react';

const NriFaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    {
      question: "Who is a Non-Resident Indian (NRI)?",
      answer: "According to FEMA regulations, a Non-Resident Indian (NRI) is referred to a citizen of India or a person of Indian origin, residing outside the country"
    },
    {
      question: "Who is a Person of Indian Origin (PIO)?",
      answer: `For the purpose of investments in equities/securities in India, a person of Indian origin is referred to a citizen of any country other than Pakistan or Bangladesh, if:
a) They at any time, held an Indian passport
b) They or either their parents or grand- parents were a citizen of India by virtue of the constitution of India or Citizenship Act, 1955 (57 of 1995)
c) The person is a spouse of an Indian citizen or a person referred to in either of the above`
    },
    {
      question: "Who is an Overseas Citizen of India (OCI)?",
      answer: `OCI; also known as Dual Citizenship, was introduced on 2nd Dec 2005 by the Government of India.
The terms of OCI state that a foreign national is eligible for registration as an Overseas Citizen of India along with their minor children and grand- children, if they were:
1) Eligible to become a citizen of India on 26.01.1950
2) A citizen of India on or at any time after 26.01.1950
3) Belonged to a territory that became part of India after 15.08.1947
Registration for OCI will be permitted only if the country of citizenship permits dual citizenship in some form or the other under the country's laws
However, applicants who are/ were citizens of Pakistan or Bangladesh are not eligible to register under OCI`
    },
    {
      question: "What is an Overseas Corporate Body (OCB)?",
      answer: "Overseas Corporate Body is a company, partnership firm, society, trust or a corporate entity in which Non- resident Indians (NRI's) have a minimum representation of 60 percent, either directly or indirectly"
    },
    {
      question: "What kind of investments can NRI's capitalize on?",
      answer: `1. Dated Government securities (other than bearer securities) or treasury bills
2. Units of domestic mutual funds
3. Bonds issued by a public sector undertaking (PSU) in India
4. Shares in Public Sector Enterprises being disinvested by the Government of India`
    },
    {
      question: "Are NRI's/PIO/ OCI permitted to invest in the Indian equity markets and mutual funds?",
      answer: `NRI's/PIO and OCI are permitted to invest directly in the equity segment on the Indian Exchanges such as BSE and NSE. They are also permitted to invest in mutual funds.
The Reserve Bank of India has authorized certain banks to conduct business under the Portfolio Investment Scheme (PIS) and NRIs will have to compulsorily route their applications through the RBI designated dealer banks`
    },
    {
      question: "What is Portfolio Investment Scheme (PIS)?",
      answer: "Portfolio Investment Scheme (PIS) is a system created by the Reserve Bank of India, under which Non Resident Indian (NRIs) can purchase and sell shares in addition to investing in convertible debentures of Indian companies on the Indian Stock Exchanges. To do this, the NRI/PIO has to open an account with a designated branch of a bank, which deals in Portfolio Investment. All transactions are expected to be routed through the designated bank ONLY"
    },
    {
      question: "Is there a Ceiling on Investments under the Portfolio Investment Scheme?",
      answer: `1) Under the PIS route, NRI's can invest up- to 5 percent of the paid- up capital/ paid up value of each series of debentures of listed Indian companies, on repatriation and non- repatriation basis
2) The aggregate paid-up value of shares / convertible debentures purchased by all NRI's cannot exceed 10 per cent of the paid-up capital of the company / paid-up value of each series of debentures of the company
3) The aggregate ceiling of 10 per cent can be raised to 24 per cent, if the General Body of the Indian company passes a special resolution to that effect`
    },
    {
      question: "Can a NRI/PIO/OCI open an account with Asiatic?",
      answer: "A Person of Indian Origin residing abroad can open trading and de-mat accounts with Asiatic, both in the NRE and NRO status. A PIO can invest in Equity Shares, Futures & Options (F&O), Initial Public Offers (IPOs) and Mutual Funds. The investments can be executed online through any of our online trading platforms or via the telephone"
    },
    {
      question: "What is the role of Asiatic?",
      hasImage: true,
      imageSrc: "assets/images/assiatne.png",
      imageAlt: "asiatic"
    },
    {
      question: "What are the other Client Registration Formalities for NRI/PIO/OCI clients?",
      answer: `Client registration documents are required to be executed by the NRI/PIO/OCI and not by a Power of Attorney Holder.
To complete the In-person verification, KYC documents should be attested by any one of the following entities in the country where the client resides`,
      hasImage: true,
      imageSrc: "assets/images/judgh-hh.png",
      imageAlt: "asiatic"
    },
    {
      question: "Is it mandatory for client's to provide proof of their Local (Indian) Address?",
      answer: "At the time of filling out the client registration, you are required to provide the documentary proof of your address abroad. However, if you intend to keep your local address as your address for correspondence, you will have also have to offer documentary evidence of your local address"
    },
    {
      question: "Supplementary Documents to open a trading with Asiatic",
      hasImage: true,
      imageSrc: "assets/images/passpor-asiatic.png",
      imageAlt: "asiatic"
    },
    {
      question: "Can NRI's open trading and de-mat accounts with Asiatic only for the purpose of Investing in IPOs and MFs?",
      answer: "Absolutely. Illustrated below are the required self- attested photocopies of documents to set- up such accounts",
      hasImage: true,
      imageSrc: "assets/images/pan-card.png",
      imageAlt: "asiatic"
    },
    {
      question: "Can an Overseas Corporate Body (OCB) invest/ trade on the Indian stock markets?",
      answer: "OCBs have been de-recognized as an investor class from September 16th 2003 and are prohibited from investing under the Portfolio Investment Scheme. However, OCBs that have already carried out investments under the PIS are permitted to continue holding such shares /convertible debentures until sold on the stock exchange"
    },
    {
      question: "What are the Modes of Payment that can be used by NRIs to purchase shares/ debentures on the Indian stock exchanges?",
      answer: `1) Payment for purchase of shares and/or debentures on Repatriation Basis-
- Remittance of foreign exchange through normal banking channels or out of funds held in NRE/FCNR (B) accounts maintained in India
2) Payment for purchase of shares and/or debentures on Non-Repatriation Basis-
- Remittance of funds from NRO account in addition to the above`
    },
    {
      question: "Where can NRIs/PIO remit Sale Proceeds?",
      answer: "If the shares sold were held on repatriation basis, the sale proceeds (net of taxes) will be credited to the NRE /FCNR (B)/NRO accounts of the NRI/PIO. However, the sale proceeds of non- repatriable investment will be credited only to NRO accounts"
    },
    {
      question: "Can NRI's Transfer Shares purchased under PIS to others under Private Arrangement?",
      answer: "Shares purchased under PIS on the Indian stock exchanges should be sold on that particular exchange only. These shares Cannot be transferred by way of sale under private arrangement or by way of gift (except by NRIs to their relatives as defined in Section 6 of Companies Act, 1956 or to a charitable trust duly registered under the laws in India) to a person resident in India or outside without prior approval of the Reserve Bank"
    },
    {
      question: "What are the Permissions/Approvals required for NRI's to subscribe to Public Issues? How can these shares be sold?",
      answer: "The issuing company can issue shares to NRI's on the basis of Specific or general permission from GoI/RBI. Therefore, individual NRI's do not require additional permissions. While crediting the sale proceeds to the NRE/NRO account, details regarding date of allotment and cost of acquisition should be provided to the designated bank, for computation of taxes"
    },
    {
      question: "Can NRI's indulge in Intra-day transactions in the cash segment?",
      answer: "NRI's have to compulsorily take delivery of shares purchased and deliver shares sold. Short Selling is not permitted"
    },
    {
      question: "Can NRI's trade in the Futures & Options segment of the Exchange?",
      answer: "NRIs are allowed to invest/ trade in the futures & options segment of the exchange out of the rupee funds held in India on Non- Repatriation Basis, subject to the limits prescribed by SEBI"
    },
    {
      question: "Can NRI's trade in Currency derivatives on the Indian Exchanges?",
      answer: "Only A person resident in India as defined in section 2(v) of FEMA Act 1999 are allowed to participate in currency derivatives on the Indian Exchanges"
    },
    {
      question: "Can Rights/Bonus Shares be issued to NRI's?",
      answer: "FEMA provisions allow Indian companies to Issue Rights / Bonus Shares to existing non-resident shareholders, subject to adherence of the applicable sectoral cap"
    },
    {
      question: "What are the rules to be followed by NRIs to trade in Equities-Futures & Options?",
      answer: `An NRI, who wishes to trade on the F&O segment, is required to approach the exchange through a Clearing Member; on behalf of whom the NRI intends to clear trades. The Exchange Clearing Corporation will in turn assign a Custodial Participant (CP) code to the NRI, based on the application received from the clearing member of the NRI.
At the time of order entry, the CP Code of the NRI should be entered in the CP Code field of the trading system.
Additionally, NRI's will have to compulsorily clear all their F&O trades through a single clearing member, at any given point of time`
    },
    {
      question: "What are the applicable Position Limits for NRI's trading in Derivative Contracts?",
      answer: `Position limits are applicable on the combined position in all derivative contracts on an underlying index/stock and they are the same as the client level position limits specified by SEBI,from time to time For Index based contracts–

Disclosure is compulsory for a person or persons acting in concert who together own 15% or more of the open interest in all derivative contracts for a particular underlying Index

For Stock option and single stock futures contracts–

Gross open positions across all the derivative contracts for a security for an individual client should not exceed:
1% of the free float market- cap (in terms of number of shares) OR 5% of open interest in all derivative contracts of the same underlying stock (in terms of number of shares)
Detailed information on position limits can be found in the International Investors Section on the NSE website http://www.nseindia.com`
    },
    {
      question: "Who monitors trades of NRIs?",
      answer: `The Reserve Bank of India monitors day- to- day investments carried out by NRIs/FIIs, based on the report sent by the designated banks. When total holdings of NRIs/FIIs hit 98 percent of the sectoral cap, the Central Bank cautions all branches of designated banks that any further purchase of shares in that particular listed company will require prior approval and once the shareholding by NRIs/FIIs touches the overall limit / sectoral cap /statutory limit, the Reserve Bank places the company in a Banned List.
Client level position limits security-wise, are made available to members on NSE's website http://www.nseindia.com
Once a company comes under the banned list, NRI's are prohibited from purchasing shares of that particular company under the Portfolio Investment Scheme. List of caution/banned RBI scrip's are available CLICK HERE`,
      hasLink: true,
      linkText: "CLICK HERE",
      linkUrl: "https://www.rbi.org.in/SCRIPTS/BS_FIIUSER.ASPX-"
    },
    {
      question: "In case a resident Indian translates to a non-resident, will they be required to change the status of their holdings from Resident to Non-Resident?",
      answer: "Section 6(5) of the FEMA Act states that NRI's can continue holding securities, which they purchased as an Indian resident, although their current status is that of a non- resident Indian, provided the funds are non-repatriable"
    },
    {
      question: "If non- resident Indians translate to Indian residents, will they be required to change the status of their holdings from non- resident to resident?",
      answer: `NRI's are expected to inform the change in their current status to the designated authorized dealer branch, through which investments were routed under the Portfolio Investment Scheme and the DP where their de-mat accounts were opened
Subsequently, a fresh de-mat account in the residential status will need to be set- up and securities transferred from the NRI to the residential de-mat account before closing down the NRI account`
    },
    {
      question: "In case NRI's translate to residents in India and vice versa, will they be required to open fresh trading accounts?",
      answer: "Yes, they are obligated to open new trading accounts and upload the new category code (01 – Resident Individual) & (11 – NRI), depending on their current residential status"
    },
    {
      question: "Are fund transfers allowed from NRE – PIS accounts to NRO accounts opened under the provision of Notification No. FEMA. 5/2000-RB dated May 3, 2000?",
      answer: "Fund transfers on account of net sale / maturity proceeds of shares / debentures (net of all applicable taxes), may be allowed by the AD Bank from NRE – PIS account of a NRI to the said NRI's NRO account"
    },
    {
      question: "Are fund transfers allowed from NRO – PIS accounts to NRE accounts opened under the provision of Notification No. FEMA.5/2000-RB dated May 3, 2000?",
      answer: `Fund transfers on account of net sale / maturity proceeds (net of all applicable taxes) of shares/ debentures may be allowed by the AD Bank from the NRO – PIS account of a NRI to the said NRI's NRE account, subject to the following conditions: -
- Transfer of funds should be within the overall ceiling of USD one million per financial year
- Subject to payment of tax, as applicable (i.e. as applicable if funds were remitted abroad)
- The AD should ensure the compliance with the limit of USD one million for transfer of funds by the NRI`
    },
    {
      question: "Can a foreign investor Invest in Shares issued by an Unlisted Company in India?",
      answer: "As per the regulations/guidelines issued by the Reserve Bank of India/Government of India, investment can be made in shares issued by an unlisted Indian company subject to compliance with FEMA provisions such as pricing, reporting, etc."
    },
    {
      question: "Can a foreign investor invest in Rights Shares issued by an Indian company at a discount?",
      answer: `There are no restrictions under FEMA for investment in Rights shares issued at a discount by an Indian company, provided the rights shares so issued are being offered at the same price to residents and non-residents. The offer on right basis to the person's resident outside India shall be:
(a) In the case of shares of a company listed on a recognized stock exchange in India, at a price as determined by the company; and
(b) In the case of shares of a company not listed on a recognized stock exchange in India, at a price which is not less than the price at which the offer on right basis is made to resident shareholders`
    },
    {
      question: "What are the regulations regarding Portfolio Investments by Registered Foreign Portfolio Investors (RFPIs)?",
      answer: `Investment by RFPI registered in accordance with SEBI guidelines including deemed RFPI [FII, QFI) is permitted. RFPI may include Asset Management Companies, Pension Funds, Mutual Funds, and Investment Trusts as Nominee Companies, Incorporated / Institutional Portfolio Managers or their Power of Attorney holders, University Funds, Endowment Foundations, Charitable Trusts and Charitable Societies.

Investment by RFPIs cannot exceed 10 per cent of the paid up capital of the Indian company. All RFPI/FII/QFI taken together cannot acquire more than 24 per cent of the paid up capital of an Indian Company.

RFPI can invest in primary issues of Non-Convertible Debentures (NCDs)/ bonds only if listing of such bonds / NCDs is committed to be done within 15 days of such investment. In case the NCDs/bonds issued to the SEBI RFPI are not listed within 15 days of issuance, for any reason, then the RFPI shall immediately dispose of these bonds/NCDs either by way of sale to a third party or to the issuer and the terms of offer to RFPI should contain a clause that the issuer of such debt securities shall immediately redeem / buyback the said securities from the RFPI in such an eventuality## What are QFIs and what are the investments they can undertake?
Qualifying financial Institution (QFI) is a person who fulfills the following criteria:

(a) Resident in a country that is a member of Financial Action task Force (FATF) or a member of a group which is a member of FATF
(b) Resident in a country that is a signatory to IOSCO's MMoU (Appendix A Signatories) or a signatory of a bilateral MoU with SEBI

PROVIDED that the person is not resident in a country listed in the public statements issued by FATF from time to time on jurisdictions having a strategic AML/CFT deficiencies to which counter measures apply or that have not made sufficient progress in addressing the deficiencies or have not committed to an action plan developed with the FATF to address the deficiencies;

Further such person is not resident in India and is not registered with SEBI as a Foreign Institutional Investor (FII) 
or Sub-Account of an FII or Foreign Venture Capital Investor (FVCI).`
    },
    {
      question: "What are the investments QFIs can undertake and the applicable caps for such investments?",
      answer: "QFIs are now being treated as deemed RFPI and rules as applicable to RFPIs shall be applicable."
    },
    {
      question: "What are the account opening charges for NRI's?",
      answer: "Account opening charges are fixed at Rs.1000, all-inclusive"
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const renderAnswer = (item) => {
    if (item.hasImage) {
      return (
        <div>
          {item.answer && <p style={{ whiteSpace: 'pre-line' }}>{item.answer}</p>}
          <img
            src={item.imageSrc}
            className="faq-image"
            alt={item.imageAlt}
          />
        </div>
      );
    }

    if (item.hasLink) {
      const parts = item.answer.split(item.linkText);
      return (
        <p style={{ whiteSpace: 'pre-line' }}>
          {parts[0]}
          <a
            href={item.linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="faq-link"
          >
            {item.linkText}
          </a>
          {parts[1]}
        </p>
      );
    }

    return <p style={{ whiteSpace: 'pre-line' }}>{item.answer}</p>;
  };

  return (
    <div className="container">
      <div className="row nri-faq-asiatic">
        <div className="col-md-12">

          <div className="faq-container">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? 'active' : ''}`}
              >
                <div
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <h4>{item.question}</h4>
                  <span className="faq-icon">
                    {openIndex === index ? '−' : '+'}
                  </span>
                </div>
                <div className="faq-answer">
                  {renderAnswer(item)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 15px;
        }

        .nri-faq-asiatic {
          background: #fff;
          border-radius: 20px;
          padding: 3rem 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          margin: 2rem 0;
          border: 1px solid #e9ecef;
        }

        .faq-item {
          background: #f8f9fa;
          border-radius: 12px;
          margin-bottom: 1rem;
          border: 2px solid transparent;
          transition: all 0.3s ease;
          overflow: hidden;
        }

        .faq-item:hover {
          border-color: #007bff;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 123, 255, 0.1);
        }

        .faq-item.active {
          border-color: #007bff;
          background: #ffffff;
          box-shadow: 0 8px 25px rgba(0, 123, 255, 0.15);
        }

        .faq-question {
          padding: 1rem 2rem;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.3s ease;
        }

        .faq-question:hover {
          background: rgba(0, 123, 255, 0.05);
        }

        .faq-question h4 {
          margin: 0;
          color: #2c3e50;
          font-weight: 600;
          font-size: 1.1rem;
          line-height: 1.4;
          flex: 1;
          padding-right: 2rem;
        }

        .faq-icon {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          font-weight: bold;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .faq-item.active .faq-icon {
          background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
          transform: rotate(180deg);
        }

        .faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: all 0.4s ease;
          background: #ffffff;
        }

        .faq-item.active .faq-answer {
          max-height: 2000px;
          padding: 0 2rem 1.5rem;
        }

        .faq-answer p {
          margin: 1rem 0;
          color: #6c757d;
          line-height: 1.6;
          font-size: 1rem;
        }

        .faq-image {
          max-width: 100%;
          height: auto;
          border-radius: 8px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          margin: 1rem 0;
          border: 1px solid #e9ecef;
        }

        .faq-link {
          color: #007bff;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 2px 6px;
          border-radius: 4px;
          background: rgba(0, 123, 255, 0.1);
          border: 1px solid rgba(0, 123, 255, 0.2);
        }

        .faq-link:hover {
          color: #0056b3;
          text-decoration: none;
          background: rgba(0, 123, 255, 0.2);
          border-color: rgba(0, 123, 255, 0.3);
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .nri-faq-asiatic {
            padding: 2rem 1rem;
            margin: 1rem 0;
          }

       
          .faq-question {
            padding: 1.25rem 1.5rem;
          }

          .faq-question h4 {
            font-size: 1rem;
            padding-right: 1.5rem;
          }

          .faq-item.active .faq-answer {
            padding: 0 1.5rem 1.25rem;
          }

          .faq-icon {
            width: 25px;
            height: 25px;
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .nri-faq-asiatic {
            padding: 1.5rem 1rem;
          }

          .faq-question {
            padding: 1rem 1.25rem;
          }

          .faq-question h4 {
            padding-right: 1.25rem;
          }

          .faq-item.active .faq-answer {
            padding: 0 1.25rem 1rem;
          }
        }

        /* Animation for smooth opening */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .faq-item.active .faq-answer {
          animation: fadeIn 0.3s ease;
        }
      `}</style>
    </div>
  );
};

export default NriFaqSection;